export default "__VITE_ASSET__5433874d__"